export const INPUT_SHIPPING_INFO = "INPUT_SHIPPING_INFO";
export const inputShippingInfo = (shippingInfoState) => {
    return {
        type: "INPUT_SHIPPING_INFO",
        payload: {
            receiver: shippingInfoState.receiver,
            furigana: shippingInfoState.furigana,
            telephone: shippingInfoState.telephone,
            postCode: shippingInfoState.postCode,
            prefecture: shippingInfoState.prefecture,
            city: shippingInfoState.city,
            address: shippingInfoState.address,
            apartmentAndRoom: shippingInfoState.apartmentAndRoom
        }
    }
}